module.exports = __webpack_public_path__ + "img/3_of_Hearts.svg.3339d5ad.png";